function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = "/home/vsts/work/1/s/src/SCF/client/src/site__csl001/components/site/sprites nonrecursive /\\.svg$/";


//////////////////
// WEBPACK FOOTER
// ./client/src/site__csl001/components/site/sprites nonrecursive \.svg$
// module id = /home/vsts/work/1/s/src/SCF/client/src/site__csl001/components/site/sprites nonrecursive /\.svg$/
// module chunks = site__csl001